<template>
  <fieldset>
    <p class="help-block">{{ trans("export.pdlLog.atLeastOneRequired") }}</p>
    <div class="form-group" :class="{ 'has-error': !!dataFormErrors?.ssn }">
      <label :for="ssnInputId">{{ trans("patient.ssn") }}</label>
      <i v-if="!userIdentifier" class="far fa-asterisk" />
      <input
        :id="ssnInputId"
        v-model="ssn"
        name="ssn"
        class="form-control"
        :placeholder="trans('forms.placeholderForPersonalNumberFormat')"
      />
      <form-error v-if="!!dataFormErrors?.ssn" :errors="dataFormErrors?.ssn" />
    </div>
    <div
      class="form-group"
      :class="{ 'has-error': !!dataFormErrors?.userIdentifier }"
    >
      <label :for="userIdentifierInputId">{{
        trans("export.userIdentifier")
      }}</label>
      <i v-if="!ssn" class="far fa-asterisk" />
      <input
        :id="userIdentifierInputId"
        v-model="userIdentifier"
        name="userIdentifier"
        class="form-control"
        :placeholder="trans('export.userIdentifierPlaceholder')"
      />
      <form-error
        v-if="!!dataFormErrors?.userIdentifier"
        :errors="dataFormErrors?.userIdentifier"
      />
    </div>
    <TimePickersMenu />
  </fieldset>
</template>
<script setup>
import { ref } from "vue";
import { v4 as uuidV4 } from "uuid";
import TimePickersMenu from "../../../../../components/Statistics/StatisticsComponents/StatisticsUtils/TimePicker.vue";
import FormError from "../../../../../components/Utils/FormError.vue";

const ssnInputId = uuidV4();
const userIdentifierInputId = uuidV4();

const ssn = ref("");
const userIdentifier = ref("");

defineProps({
  dataFormErrors: {
    type: /** @type {Record<'ssn'|'userIdentifier'|'fromDate'|'untilDate', string|string[]>} */ Object,
  },
});
</script>
